export default "__VITE_ASSET__BfoiFfRP__"